/*
 * floatingReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 18-Jun-2025
 */

import { produce } from 'immer'
import { actionTypes } from '../actions/floating'

const ACTION_HANDLERS = {
  [actionTypes.DO_SHOW_FLOATING]: produce((draft, action) => {
    draft.floatingKey = action.key
    draft.floatingInfo = action.moreInfo
  }),
  [actionTypes.DO_HIDE_FLOATING]: produce((draft) => {
    draft.floatingKey = ''
    draft.floatingInfo = {}
  }),
  // Listener per aggiornare il loading quando inizia il download degli accrediti
  '@@Costs/get_download_credit_request': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = true
    }
  }),
  '@@Costs/get_download_credit_success': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  '@@Costs/get_download_credit_failure': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  // Listener per aggiornare il loading quando inizia il download degli addebiti
  '@@Costs/get_download_debit_request': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = true
    }
  }),
  '@@Costs/get_download_debit_success': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  '@@Costs/get_download_debit_failure': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  // Listener per aggiornare il loading quando inizia il download delle commissioni
  '@@Costs/get_download_commissions_request': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = true
    }
  }),
  '@@Costs/get_download_commissions_success': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  '@@Costs/get_download_commissions_failure': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  // Listener per aggiornare il loading quando inizia il download dei dettagli accrediti
  '@@Costs/get_download_credit_details_request': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = true
    }
  }),
  '@@Costs/get_download_credit_details_success': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  '@@Costs/get_download_credit_details_failure': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  // Listener per aggiornare il loading quando inizia il download dei dettagli addebiti
  '@@Costs/get_download_debit_details_request': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = true
    }
  }),
  '@@Costs/get_download_debit_details_success': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  '@@Costs/get_download_debit_details_failure': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  // Listener per aggiornare il loading quando inizia il download massivo delle transazioni autorizzate
  '@@Transactions/get_download_authorized_transactions_request': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = true
    }
  }),
  '@@Transactions/get_download_authorized_transactions_success': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  '@@Transactions/get_download_authorized_transactions_failure': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  // Listener per aggiornare il loading quando inizia il download massivo delle transazioni contabilizzate
  '@@Transactions/get_download_accounted_transactions_request': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = true
    }
  }),
  '@@Transactions/get_download_accounted_transactions_success': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  }),
  '@@Transactions/get_download_accounted_transactions_failure': produce((draft) => {
    if (draft.floatingKey === 'GENERIC_FLOATING_DOWNLOAD_TILE') {
      draft.floatingInfo.loading = false
    }
  })
  // @generator reducer:type:action
}

// The initial state of the floating
const initialState = {
  floatingKey: '',
  floatingInfo: {}
}

const floating = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default floating
